var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_356_1303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7222 6.22222H8.27778V0.777778C8.27778 0.571498 8.19583 0.373667 8.04997 0.227806C7.90411 0.0819442 7.70628 0 7.5 0C7.29372 0 7.09589 0.0819442 6.95003 0.227806C6.80417 0.373667 6.72222 0.571498 6.72222 0.777778V6.22222H1.27778C1.0715 6.22222 0.873667 6.30417 0.727806 6.45003C0.581944 6.59589 0.5 6.79372 0.5 7C0.5 7.20628 0.581944 7.40411 0.727806 7.54997C0.873667 7.69583 1.0715 7.77778 1.27778 7.77778H6.72222V13.2222C6.72222 13.4285 6.80417 13.6263 6.95003 13.7722C7.09589 13.9181 7.29372 14 7.5 14C7.70628 14 7.90411 13.9181 8.04997 13.7722C8.19583 13.6263 8.27778 13.4285 8.27778 13.2222V7.77778H13.7222C13.9285 7.77778 14.1263 7.69583 14.2722 7.54997C14.4181 7.40411 14.5 7.20628 14.5 7C14.5 6.79372 14.4181 6.59589 14.2722 6.45003C14.1263 6.30417 13.9285 6.22222 13.7222 6.22222Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_356_1303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePlus);
export default __webpack_public_path__ + "static/media/white-plus.e1c6853fdbd1f88902d4b2695597033d.svg";
export { ForwardRef as ReactComponent };